import styled from '@emotion/styled';
import { Swiper, SwiperSlide } from 'swiper/react';

import { forMobile } from '@/design-system';
import { MOBILE_PAGE_PADDING } from '@/pages/portfolio/portfolio.styled';

const CONTROLS_HEIGHT = 48;

export const CarouselRoot = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  gap: theme.spacing[24],

  [forMobile]: {
    gap: theme.spacing[16],
  },
}));

export const CarouselHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
  minHeight: CONTROLS_HEIGHT,

  [forMobile]: {
    minHeight: 'auto',
  },
}));

export const CarouselControls = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing[8],
}));

export const StyledSwiper = styled(Swiper)({
  width: '100%',

  [forMobile]: {
    width: 'auto',
    marginInline: -MOBILE_PAGE_PADDING,
  },
});

export const StyledSwiperSlide = styled(SwiperSlide)({
  width: 'fit-content',
});
